var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNudgeLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_331",
    "data-name": "Group 331",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256.939,
    height: 76.246,
    viewBox: "0 0 256.939 76.246",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M256.779,317.737H245.11V298.97a72.521,72.521,0,0,0-.222-7.433q-.665-4.747-3.1-6.624a7.885,7.885,0,0,0-4.653-1.325c-5.022,0-8.271,2.723-9.675,8.243-.369,1.325-.517,4.269-.517,8.684v17.222H215.2V274.9h11.669v4.342c4.8-3.68,9.379-5.446,13.884-5.446a16.805,16.805,0,0,1,11.816,4.416c2.733,2.5,4.062,6.256,4.062,11.187v28.335Z",
    transform: "translate(-215.2 -258.271)",
    fill: "#3fb6e8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M322.083,297.188c-1.92,7.212-3.914,12-5.834,14.351-4.948,5.888-11.89,7.654-20.826,5.225-9.675-2.576-14.844-8.1-15.435-16.486-.222-2.8.591-7.507,2.363-14.057L287,269l11.521,3.091-5.391,19.945a34.818,34.818,0,0,0-1.329,6.4,7.846,7.846,0,0,0,1.92,6.182,8.754,8.754,0,0,0,4.357,2.5c3.84,1.03,6.868.074,9.01-2.8.812-1.03,1.7-3.533,2.733-7.433l5.465-20.239,11.447,3.091Z",
    transform: "translate(-232.131 -257.004)",
    fill: "#3fb6e8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M395.747,312.166H384V307.6a21.617,21.617,0,0,1-14.4,5.667,21.243,21.243,0,0,1-16.174-6.845,21.923,21.923,0,0,1-6.13-15.6,22.622,22.622,0,0,1,5.834-15.75,22.032,22.032,0,0,1,30.944-1.1V252.7h11.743v59.466Zm-11.226-21.49a12.012,12.012,0,0,0-3.545-8.905,12.665,12.665,0,0,0-9.379-3.533,12.424,12.424,0,0,0-9.305,3.68,12.135,12.135,0,0,0-3.4,8.832,12.489,12.489,0,0,0,3.471,8.905,12.223,12.223,0,0,0,9.305,3.827,12.25,12.25,0,0,0,12.85-12.806Z",
    transform: "translate(-249.741 -252.7)",
    fill: "#3fb6e8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M470.421,311.576c0,7.213-1.625,12.585-4.8,15.971-4.283,4.637-10.782,6.918-19.349,6.918-8.641,0-15.14-2.061-19.571-6.182a19.309,19.309,0,0,1-4.8-7.433h12.924c2.363,2.5,5.982,3.68,10.856,3.68q8.973,0,11.743-4.857c.812-1.4,1.182-3.9,1.182-7.36a20.474,20.474,0,0,1-14.254,5.3,22.022,22.022,0,0,1-16.321-6.55,21.1,21.1,0,0,1-6.13-15.455c0-6.771,2.289-12.291,6.868-16.412a21.478,21.478,0,0,1,14.918-5.593,22.146,22.146,0,0,1,14.844,5.814V274.7h11.743v36.872Zm-11.152-15.75a11.454,11.454,0,0,0-3.471-8.611,14.179,14.179,0,0,0-18.389,0,12.054,12.054,0,0,0,0,17.222,13.159,13.159,0,0,0,9.379,3.459,12.5,12.5,0,0,0,9.158-3.459A11.922,11.922,0,0,0,459.269,295.826Z",
    transform: "translate(-269.247 -258.218)",
    fill: "#3fb6e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M545.607,297.3l-.074,2.061H507.721a10.867,10.867,0,0,0,4.5,7.286,14.732,14.732,0,0,0,8.936,2.576,16.274,16.274,0,0,0,11.3-4.2l9.9,4.269c-4.8,6.256-11.89,9.42-21.2,9.42-7.238,0-13.146-2.061-17.872-6.256a20.325,20.325,0,0,1-7.09-16.044,21.527,21.527,0,0,1,6.868-16.265c4.579-4.342,10.339-6.55,17.429-6.55,7.385,0,13.367,2.134,18.02,6.477A21.664,21.664,0,0,1,545.607,297.3Zm-11.89-6.4a10.778,10.778,0,0,0-4.653-5.888,14.865,14.865,0,0,0-7.828-2.134,14.67,14.67,0,0,0-8.567,2.5,13.951,13.951,0,0,0-4.283,5.52Z",
    transform: "translate(-288.675 -258.218)",
    fill: "#3fb6e8"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNudgeLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nudge-logo.8596dc29be43c8368d569d4fbc29f113.svg";